var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#close_circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.929 4.929c-3.903 3.903-3.903 10.239 0 14.142 3.903 3.903 10.239 3.903 14.142 0 3.903-3.903 3.903-10.239 0-14.142-3.903-3.903-10.239-3.903-14.142 0Zm11.314 4.243L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586l2.828-2.829 1.415 1.415Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close_circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})))));
export default SvgCloseCircle;